import { ISapSyncLog } from 'features/settings/history/types';
import { BaseService } from 'shared/services/BaseService';

class SapSyncLogService extends BaseService<ISapSyncLog> {
  constructor() {
    super('sap-logging');
  }
  canBulkDelete = true;
}

export const sapSyncLogService = new SapSyncLogService();
